import { CompanyRole } from '@/constants';
import keycloakAxios from '@/services/axios';

export const setEmployeeRole = async (
  employeeId: string,
  role: CompanyRole,
  companyId: string
) => {
  const endpoint = `company/${companyId}/employee/${employeeId}`;

  const response = await keycloakAxios.post(endpoint, {
    role: role
  });

  if (response.status >= 300) {
    throw new Error(
      `Error updating employee role: Invalid status code: ${response.status}`
    );
  }

  return response.data;
};
